module.exports = __webpack_public_path__ + "img/ant.07162b36.png";